import React from 'react';
import { Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

/**
 * 推荐位 - 模板卡片选择面板（横向滚动）
 * 真实项目：views/operation/recommended/components/TemplateCardPanel.vue
 */
const RecommendTemplatePanel = ({ templates = [], selectedCode = '', showManageButton = true, onSelect, onManage }) => (
    <div style={{ marginTop: 8, paddingLeft: 12 }}>
        <div style={{ overflowX: 'auto', overflowY: 'hidden', paddingBottom: 6 }}>
            <div style={{ display: 'flex', flexWrap: 'nowrap', gap: 10, width: 'max-content' }}>
                {templates.map(tpl => {
                    const selected = tpl.code === selectedCode;
                    return (
                        <div
                            key={tpl.code}
                            onClick={() => onSelect(tpl.code)}
                            style={{ width: 120, flexShrink: 0, cursor: 'pointer', position: 'relative', border: `${selected ? 2 : 1}px solid ${selected ? '#409eff' : '#e4e7ed'}`, borderRadius: 8, padding: 6 }}
                        >
                            {selected && (
                                <div style={{ position: 'absolute', top: -6, right: -6, width: 22, height: 22, borderRadius: '50%', background: '#409eff', color: '#fff', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>✓</div>
                            )}
                            <div style={{ aspectRatio: '9 / 16', borderRadius: 8, overflow: 'hidden', background: '#f5f7fa' }}>
                                <img src={tpl.image} alt={tpl.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                            <div style={{ marginTop: 6, fontSize: 13, color: '#303133', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tpl.name}</div>
                        </div>
                    );
                })}
            </div>
        </div>
        {showManageButton && (
            <div style={{ marginTop: 10 }}>
                <Button type="link" icon={<SettingOutlined />} onClick={onManage}>管理模板</Button>
            </div>
        )}
    </div>
);

export default RecommendTemplatePanel;
